import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomepageComponent} from './homepage.component';
import {HomepageIconsComponent} from './homepage-icons/homepage-icons.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [HomepageComponent, HomepageIconsComponent],
  exports: [HomepageComponent]
})
export class HomepageModule {
}



// WEBPACK FOOTER //
// ./src/app/components/homepage/homepage.module.ts